
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequirefc28"];
var parcelRegister = parcelRequire.register;
parcelRegister("8DKe5", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "ExternalLinks", () => $d6c8b655d036d856$export$7c6fdaf98295312b);
$parcel$export(module.exports, "default", () => $d6c8b655d036d856$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $fT4XN = parcelRequire("fT4XN");

var $3EoZy = parcelRequire("3EoZy");

var $jBiia = parcelRequire("jBiia");

var $7WRjA = parcelRequire("7WRjA");

var $lz7dO = parcelRequire("lz7dO");
parcelRequire("2vq3B");
var $c5bfu = parcelRequire("c5bfu");
const $d6c8b655d036d856$export$7c6fdaf98295312b = ({ projectId: projectId })=>{
    (0, $7WRjA.useUFOComponentExperience)((0, $lz7dO.externalLinksProductExperience));
    const [isShowAll, setIsShowAll] = (0, $bSJIT.useState)(false);
    const [links, setLinks] = (0, $bSJIT.useState)([]);
    (0, $bSJIT.useEffect)(()=>{
        (0, $3EoZy.fetchExternalLinks)(projectId).toPromise().then((response)=>{
            setLinks(response.links);
            if (response.links.length < (0, $c5bfu.EXTERNAL_LINKS_TO_BE_SHOWN)) setIsShowAll(true);
        }).catch((error)=>{
            /**
       * Send experience failure events only when fetch external links API call responds
       * with a status of 5xx or 404.
       */ if (`${error.status}`.startsWith('5') || error.status === 404) (0, $lz7dO.externalLinksProductExperience).failure({
                metadata: {
                    error: (0, $jBiia.getErrorData)(error)
                }
            }).catch((err)=>{
                (0, $jBiia.trackError)('An AJAX error occurred inside the external links experience, but failed to send experience failure event', {}, err);
            });
            setLinks([]);
        });
    }, [
        projectId
    ]);
    const onShowMoreToggle = (0, $bSJIT.useCallback)(()=>{
        setIsShowAll((val)=>{
            return !val;
        });
    }, []);
    const markExperienceFailure = (0, $bSJIT.useCallback)((error)=>{
        (0, $jBiia.trackError)('ExternalLink experience failed', {}, error);
        // Send experience failure event when JS or HTTP errors occur.
        (0, $lz7dO.externalLinksProductExperience).failure({
            metadata: {
                error: (0, $jBiia.getErrorData)(error)
            }
        }).catch((err)=>{
            (0, $jBiia.trackError)('A JS/HTTP error occurred inside the external links experience, but failed to send experience failure event', {}, err);
        });
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $fT4XN.default), {
        id: "jsmPortalExternalResourcesSection",
        packageName: "jsmPortalExternalResourcesSection",
        onError: markExperienceFailure
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $c5bfu.default), {
        links: isShowAll ? links : links.slice(0, (0, $c5bfu.EXTERNAL_LINKS_TO_BE_SHOWN)),
        total: links.length,
        onShowMoreToggle: onShowMoreToggle
    }));
};
var $d6c8b655d036d856$export$2e2bcd8739ae039 = $d6c8b655d036d856$export$7c6fdaf98295312b;

});
parcelRegister("3EoZy", function(module, exports) {
$parcel$export(module.exports, "fetchExternalLinks", () => $87e4adc1c201e82d$export$633b48ab7e391339);

var $lJ0l5 = parcelRequire("lJ0l5");

var $llRGw = parcelRequire("llRGw");

var $fuVmc = parcelRequire("fuVmc");
const $87e4adc1c201e82d$export$633b48ab7e391339 = (projectId)=>{
    const tenantId = (0, $fuVmc.getMeta)('tenant-id') || '';
    const url = `/gateway/api/jira/help-kosh/cloudid/${tenantId}/api/v1/external-links/project/${projectId}`;
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (0, $llRGw.get)(url).map(({ response: response })=>response).catch((e)=>{
        return (0, $lJ0l5.Observable).throw(e);
    });
};

});

parcelRegister("lz7dO", function(module, exports) {
$parcel$export(module.exports, "externalLinksProductExperience", () => $270de59710115dd9$export$cc7c1a822aff47f7);

var $eAZuG = parcelRequire("eAZuG");

var $7r7ey = parcelRequire("7r7ey");
var $1we90 = parcelRequire("1we90");
const $270de59710115dd9$export$cc7c1a822aff47f7 = new (0, $1we90.UFOExperience)((0, $eAZuG.externalLinksProductExperienceId), {
    type: (0, $7r7ey.ExperienceTypes).Load,
    performanceType: (0, $7r7ey.ExperiencePerformanceTypes).PageSegmentLoad
});

});

parcelRegister("2vq3B", function(module, exports) {
$parcel$export(module.exports, "ExternalLinksStateless", () => (parcelRequire("c5bfu")).default);
$parcel$export(module.exports, "EXTERNAL_LINKS_TO_BE_SHOWN", () => (parcelRequire("c5bfu")).EXTERNAL_LINKS_TO_BE_SHOWN);

var $c5bfu = parcelRequire("c5bfu");

});
parcelRegister("c5bfu", function(module, exports) {
$parcel$export(module.exports, "EXTERNAL_LINKS_TO_BE_SHOWN", () => $12365b1485f53edf$export$153afb56ed7fbf28);
$parcel$export(module.exports, "default", () => $12365b1485f53edf$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $4v2A7 = parcelRequire("4v2A7");

var $lCAV6 = parcelRequire("lCAV6");

var $fK3tS = parcelRequire("fK3tS");

var $c3QJe = parcelRequire("c3QJe");

var $6WltM = parcelRequire("6WltM");
var $2usNr = parcelRequire("2usNr");

var $7WQx2 = parcelRequire("7WQx2");

var $gRfjb = parcelRequire("gRfjb");

var $haAAx = parcelRequire("haAAx");

var $f6Ax9 = parcelRequire("f6Ax9");

var $lz7dO = parcelRequire("lz7dO");
parcelRequire("ajnYE");
var $6yuOE = parcelRequire("6yuOE");

var $7MzvW = parcelRequire("7MzvW");
const $12365b1485f53edf$export$153afb56ed7fbf28 = 3;
const $12365b1485f53edf$export$f1b0b08c3839d870 = (props)=>{
    const [isPageInEditMode] = (0, $c3QJe.useIsPageInEditMode)();
    const { links: links, total: total, onShowMoreToggle: onShowMoreToggle, intl: { formatMessage: formatMessage } } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6WltM.useAnalyticsEvents)();
    (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useEffect(()=>{
        if (total > 0) {
            const event = createAnalyticsEvent({
                analyticsType: (0, $haAAx.UI_EVENT_TYPE),
                action: 'viewed',
                links_count: total
            });
            event.fire();
        }
    }, [
        createAnalyticsEvent,
        total
    ]);
    if (links.length < 1) return null;
    const doesMoreLinkExists = total > links.length;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $haAAx.AnalyticsContext), {
        attributes: {
            links_count: total
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($12365b1485f53edf$var$ExternalLinksWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $7WQx2.default), {
        size: "small",
        as: "h2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($12365b1485f53edf$var$LabelWithIcon, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gRfjb))), {
        spacing: "spacious",
        label: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("span", null, formatMessage((0, $7MzvW.default).externalLinksSectionHeader)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("ul", null, links.map((link, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $6yuOE.default), {
            ...link,
            key: link.id,
            position: index + 1,
            isPageInEditMode: isPageInEditMode
        }))), total > $12365b1485f53edf$export$153afb56ed7fbf28 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($12365b1485f53edf$var$ShowMoreButton, {
        appearance: "link",
        actionSubjectId: doesMoreLinkExists ? 'show-more-external-resources' : 'show-less-external-resources',
        onClick: onShowMoreToggle
    }, doesMoreLinkExists ? formatMessage((0, $7MzvW.default).externalLinksSectionShowMore) : formatMessage((0, $7MzvW.default).externalLinksSectionShowLess)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $f6Ax9.ExperienceSuccess), {
        experience: (0, $lz7dO.externalLinksProductExperience)
    })));
};
var $12365b1485f53edf$export$2e2bcd8739ae039 = (0, $fK3tS.default)((0, $2usNr.default)({
    component: 'externalResources'
})($12365b1485f53edf$export$f1b0b08c3839d870));
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $12365b1485f53edf$var$ExternalLinksWrapper = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-1mcvhek-0"
})`ul{padding-left:${"var(--ds-space-0, 0px)"};}`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $12365b1485f53edf$var$LabelWithIcon = /*#__PURE__*/ (0, $4v2A7.default).label.withConfig({
    componentId: "sc-1mcvhek-1"
})`display:flex;align-items:center;> :not(:last-child){margin-right:${"var(--ds-space-100, 8px)"};}`;
//@ts-ignore TypeScript upgrade 5.1.6, please fix this violation.
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $12365b1485f53edf$var$ShowMoreButton = /*#__PURE__*/ (0, $4v2A7.default)((0, $lCAV6.ThemedButton)).withConfig({
    componentId: "sc-1mcvhek-2"
})`margin-top:${"var(--ds-space-100, 8px)"};&:hover{text-decoration:none;}`;

});
parcelRegister("ajnYE", function(module, exports) {
$parcel$export(module.exports, "ExternalLinkItem", () => (parcelRequire("6yuOE")).default);

var $6yuOE = parcelRequire("6yuOE");

});
parcelRegister("6yuOE", function(module, exports) {
$parcel$export(module.exports, "default", () => $5d1e5299dbea03f7$export$2e2bcd8739ae039);

var $egQxE = parcelRequire("egQxE");

var $fK3tS = parcelRequire("fK3tS");

var $aI0YR = parcelRequire("aI0YR");

var $2usNr = parcelRequire("2usNr");

var $eocWW = parcelRequire("eocWW");
const $5d1e5299dbea03f7$var$mapStateToProps = (state)=>{
    return {
        isLoggedIn: (0, $aI0YR.isLoggedIn)(state)
    };
};
var $5d1e5299dbea03f7$export$2e2bcd8739ae039 = (0, $fK3tS.default)((0, $2usNr.default)({
    component: 'externalResourceItem'
})((0, $egQxE.connect)($5d1e5299dbea03f7$var$mapStateToProps)((0, $eocWW.ExternalLinkItem))));

});
parcelRegister("eocWW", function(module, exports) {
$parcel$export(module.exports, "ExternalLinkItem", () => $3dca7844332a340f$export$1807a95eb422ac5c);

var $bSJIT = parcelRequire("bSJIT");

var $4v2A7 = parcelRequire("4v2A7");

var $5VhGP = parcelRequire("5VhGP");

var $fU62V = parcelRequire("fU62V");

var $6WltM = parcelRequire("6WltM");

var $87QgR = parcelRequire("87QgR");

var $7WQx2 = parcelRequire("7WQx2");

var $67YKA = parcelRequire("67YKA");

var $3I5RS = parcelRequire("3I5RS");

var $eYvps = parcelRequire("eYvps");

var $edmwx = parcelRequire("edmwx");

var $lavtv = parcelRequire("lavtv");

var $haAAx = parcelRequire("haAAx");
parcelRequire("9zszD");
var $fbK1P = parcelRequire("fbK1P");

var $5yVGt = parcelRequire("5yVGt");

var $fvsji = parcelRequire("fvsji");
const $3dca7844332a340f$var$ISSUE_A11Y_37386 = 'issue-a11y-37386';
const $3dca7844332a340f$var$HC_ADS_DROP_COMMIT_2 = 'hc_ads_drop_commit_2';
const $3dca7844332a340f$var$isIssueA11y37386Enabled = ()=>(0, $87QgR.default).checkGate($3dca7844332a340f$var$ISSUE_A11Y_37386);
const $3dca7844332a340f$export$1807a95eb422ac5c = (props)=>{
    const { title: title, description: description, resourceType: resourceType, link: link, position: position, isLoggedIn: isLoggedIn, isPageInEditMode: isPageInEditMode, intl: { formatMessage: formatMessage } } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6WltM.useAnalyticsEvents)();
    const { data: iconUrl, isLoading: isIconLoading } = (0, $fbK1P.useExternalLinkIcon)({
        link: link,
        isLoggedIn: isLoggedIn
    });
    const isHcAdsDropCommit2Enabled = (0, $87QgR.default).checkGate($3dca7844332a340f$var$HC_ADS_DROP_COMMIT_2);
    const getIconLabel = (iconType)=>{
        switch(iconType){
            case 'request-form':
                return formatMessage((0, $5yVGt.default).externalLinkRequestFormIconLabel);
            case 'knowledge':
                return formatMessage((0, $5yVGt.default).externalLinkKnowledgeIconLabel);
            case 'channel':
            default:
                return formatMessage((0, $5yVGt.default).externalLinkHelpChannelIconLabel);
        }
    };
    const getFallbackIcon = (iconType)=>{
        const iconLabel = $3dca7844332a340f$var$isIssueA11y37386Enabled() ? '' : getIconLabel(iconType);
        switch(iconType){
            case 'request-form':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($edmwx))), {
                    spacing: "spacious",
                    label: iconLabel,
                    testId: "external-link-icon-request-form"
                });
            case 'knowledge':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3I5RS))), {
                    label: iconLabel,
                    size: "medium",
                    spacing: "compact",
                    testId: "external-link-icon-knowledge"
                });
            case 'channel':
            default:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eYvps))), {
                    spacing: "spacious",
                    label: iconLabel,
                    testId: "external-link-icon-channel"
                });
        }
    };
    const onLinkClick = (0, $bSJIT.useCallback)(()=>{
        if (isPageInEditMode) return;
        const analyticsEvent = createAnalyticsEvent({
            resourceType: resourceType,
            analyticsType: (0, $haAAx.UI_EVENT_TYPE),
            action: 'clicked',
            link_position: position
        });
        analyticsEvent.fire();
    }, [
        createAnalyticsEvent,
        isPageInEditMode,
        position,
        resourceType
    ]);
    const getIcon = ()=>{
        if (isIconLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5VhGP.SkeletonItem), {
            height: (0, $fvsji.iconDimension),
            width: (0, $fvsji.iconDimension)
        });
        if (iconUrl) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("img", {
            src: iconUrl,
            alt: ""
        });
        return getFallbackIcon(resourceType);
    };
    const linkContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("a", {
        target: "_blank",
        rel: "noopener noreferrer",
        href: link,
        onClick: onLinkClick,
        tabIndex: isPageInEditMode ? -1 : undefined
    }, isHcAdsDropCommit2Enabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $67YKA.default), {
        size: "small",
        icon: ()=>getIcon(),
        label: "",
        appearance: "gray"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($3dca7844332a340f$var$IconWrapper, null, getIcon()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($3dca7844332a340f$var$ContentWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $7WQx2.default), {
        size: "xsmall",
        as: "h3"
    }, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("p", null, description)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($3dca7844332a340f$var$LinkWrapper, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
        className: "cv-exclude-from-customisation",
        isPageInEditMode: isPageInEditMode,
        useIconTile: isHcAdsDropCommit2Enabled
    }, !isPageInEditMode ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $lavtv.default), {
        content: formatMessage((0, $5yVGt.default).externalLinkHoverTooltip),
        position: "mouse"
    }, linkContent) : linkContent);
};
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $3dca7844332a340f$var$LinkWrapper = /*#__PURE__*/ (0, $4v2A7.default).li.withConfig({
    componentId: "sc-eeidby-0"
})`list-style:none;a{display:flex;cursor:pointer;padding:${"var(--ds-space-050, 4px)"};gap:${({ useIconTile: useIconTile })=>useIconTile ? "var(--ds-space-200, 16px)" : undefined};pointer-events:${({ isPageInEditMode: isPageInEditMode })=>{
    return isPageInEditMode ? 'none' : 'auto';
}};&:hover,&:active,&:focus{text-decoration:none;background-color:${"var(--ds-background-neutral-subtle-hovered, #FAFBFC)"};}}`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $3dca7844332a340f$var$ContentWrapper = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-eeidby-1"
})`flex:1;${$fU62V.multiLineClamp(4)};word-break:break-word;& p{margin-top:${"var(--ds-space-050, 4px)"};color:${"var(--ds-text-subtlest, #505F79)"};}`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $3dca7844332a340f$var$IconWrapper = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-eeidby-2"
})`margin-right:${"var(--ds-space-200, 16px)"};margin-top:${"var(--ds-space-050, 4px)"};min-width:${(0, $fvsji.iconDimension)};color:${"var(--ds-icon, #172B4D)"};& img{height:${(0, $fvsji.iconDimension)};object-fit:contain;}`;

});
parcelRegister("9zszD", function(module, exports) {
$parcel$export(module.exports, "useExternalLinkIcon", () => (parcelRequire("fbK1P")).useExternalLinkIcon);

var $fbK1P = parcelRequire("fbK1P");

});
parcelRegister("fbK1P", function(module, exports) {
$parcel$export(module.exports, "useExternalLinkIcon", () => $a6b771cef0a83715$export$3e74479e59c03d8b);

var $bSJIT = parcelRequire("bSJIT");

var $dyYIc = parcelRequire("dyYIc");

var $3qDrS = parcelRequire("3qDrS");
const $a6b771cef0a83715$export$2c4a28c399ed5beb = (urls)=>{
    return (0, $dyYIc.fetchObjectsFromUrls)(urls).toPromise().then((response)=>{
        return urls.reduce((ref, url, index)=>({
                ...ref,
                // Suppressing existing violation. Please fix this.
                // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
                [url]: response[index]
            }), {});
    });
};
const $a6b771cef0a83715$var$batchedFetchIcon = (0, $3qDrS.default)($a6b771cef0a83715$export$2c4a28c399ed5beb, 0);
const $a6b771cef0a83715$export$89d9bd8ccd64e87c = {};
const $a6b771cef0a83715$var$addIconToCache = (key, value)=>{
    // @ts-ignore TS(7053) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    $a6b771cef0a83715$export$89d9bd8ccd64e87c[key] = value;
};
function $a6b771cef0a83715$export$3e74479e59c03d8b({ isLoggedIn: isLoggedIn, link: url }) {
    const [data, setData] = (0, $bSJIT.useState)(null);
    const [isLoading, setIsLoading] = (0, $bSJIT.useState)(true);
    const markDataLoaded = (key, value)=>{
        setIsLoading(false);
        setData(value);
        $a6b771cef0a83715$var$addIconToCache(key, value);
    };
    (0, $bSJIT.useEffect)(()=>{
        let href = url;
        if (!isLoggedIn) {
            markDataLoaded(url, null);
            return;
        }
        /**
     * Try to parse the url and extract out the href
     * if it fails return null as the icon url
     */ try {
            href = new URL(url).href;
        } catch (error) {
            markDataLoaded(url, null);
            return;
        }
        /**
     * Origin is null for other supported url forms like `tel:` and `mail:`
     * return null so that ui can fallback to default icons
     */ if (new URL(url).origin === 'null') {
            markDataLoaded(url, null);
            return;
        }
        /**
     * check is there is already entry in cache
     * if yes, return the icon url
     * else, make a call to object resolver service
     */ if (Object.keys($a6b771cef0a83715$export$89d9bd8ccd64e87c).includes(href)) {
            // @ts-ignore TS(7053) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
            // Suppressing existing violation. Please fix this.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            const iconUrl = $a6b771cef0a83715$export$89d9bd8ccd64e87c[href];
            setData(iconUrl);
            setIsLoading(false);
        } else $a6b771cef0a83715$var$batchedFetchIcon(href).then((response)=>{
            var _response$href;
            // TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
            // @ts-ignore TS(7053) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
            // Suppressing existing violation. Please fix this.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
            const iconUrl = (_response$href = response[href]) === null || _response$href === void 0 || (_response$href = _response$href.body) === null || _response$href === void 0 || (_response$href = _response$href.data) === null || _response$href === void 0 || (_response$href = _response$href.generator) === null || _response$href === void 0 || (_response$href = _response$href.icon) === null || _response$href === void 0 ? void 0 : _response$href.url;
            markDataLoaded(href, iconUrl ?? null);
        }).catch(()=>{
            return null;
        }).finally(()=>{
            setIsLoading(false);
        });
    }, [
        isLoggedIn,
        url
    ]);
    return {
        data: data,
        isLoading: isLoading
    };
}

});


parcelRegister("5yVGt", function(module, exports) {
$parcel$export(module.exports, "default", () => $43326781607b96aa$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
var $43326781607b96aa$export$2e2bcd8739ae039 = (0, $f0Pt4.defineMessages)({
    externalLinkRequestFormIconLabel: {
        id: 'cv.external-links.link.external-link-request-form-icon-label',
        defaultMessage: 'Request form',
        description: 'Label for Request form external link icon'
    },
    externalLinkKnowledgeIconLabel: {
        id: 'cv.external-links.link.external-link-knowledge-icon-label',
        defaultMessage: 'Knowledge',
        description: 'The text is shown as an accessible icon label for an external link of type "Knowledge" in the related resources section of a help center portal page.'
    },
    externalLinkHelpChannelIconLabel: {
        id: 'cv.external-links.link.external-link-help-channel-icon-label',
        defaultMessage: 'Help channel',
        description: 'The text is shown as an accessible icon label for an external link of type "Help channel" in the related resources section of a help center portal page.'
    },
    externalLinkHoverTooltip: {
        id: 'cv.external-links.link.external-link-hover-tooltip',
        defaultMessage: 'Opens in new tab',
        description: 'The text is shown as a tooltip on an external link item when the user hovers over it, indicating that the link will open in a new browser tab.'
    }
});

});

parcelRegister("fvsji", function(module, exports) {
$parcel$export(module.exports, "iconDimension", () => $7ff9096b2495e4a5$export$3b332b9dae1acea2);

var $9K7mZ = parcelRequire("9K7mZ");
const $7ff9096b2495e4a5$export$3b332b9dae1acea2 = $9K7mZ.multiple(3).px;

});




parcelRegister("7MzvW", function(module, exports) {
$parcel$export(module.exports, "default", () => $941e286ab18f78bb$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
var $941e286ab18f78bb$export$2e2bcd8739ae039 = (0, $f0Pt4.defineMessages)({
    externalLinksSectionHeader: {
        id: 'cv.external-links.section.header',
        defaultMessage: 'Related resources',
        description: 'The text is shown as a section heading above the list of related external resource links on a help center portal page.'
    },
    externalLinksSectionShowMore: {
        id: 'cv.external-links.section.show-more',
        defaultMessage: 'Show all',
        description: 'Label for the external links Show all button'
    },
    externalLinksSectionShowLess: {
        id: 'cv.external-links.section.show-less',
        defaultMessage: 'Show fewer',
        description: 'Label for the external links Show all button'
    }
});

});





//# sourceMappingURL=external-links.544f517d.js.map
